// extracted by mini-css-extract-plugin
export default {"container":"InfiniteCalendarSeries-module__container___zDzwE","headerText":"InfiniteCalendarSeries-module__headerText___3kgKP"};